import {makeStyles, Theme} from "@material-ui/core/styles";
import {rightArrow} from "../../asset";

const useStyles = makeStyles((theme: Theme) => ({
    tblContainer: {
        // maxHeight:'375px',
    },
    tblHeader:{
        "& th": {
            //  backgroundColor:'#fbfbfb',
            backgroundColor:'#fff',
            color: '#000',
            textTransform:'uppercase',
            fontSize:'14px',
            padding:'10px 5px !important',
            fontWeight:'bold',
        },

    },
    tblBody:{
        "& th": {
            backgroundColor:'#fff',
            color: '#000',
            textTransform:'uppercase',
            fontSize:'14px',
            padding:'6px 5px !important',
            fontWeight:'bold',
        },
        "& td": {
            color: '#000',
            backgroundColor: '#fff;',
            fontSize: '14px',
            padding:'6px 5px !important',
            textTransform: 'uppercase',
            borderBottom:'1px solid #ededed !important',
        },
    },
    tblOuterBG:{
        backgroundColor: '#fff;',
        padding: '10px',
        borderRadius: '15px',
    },


    // Status Lables
    statusBlockWrapper:{
        float: 'left',
    background: '#fff',
    padding: '10px',
    borderRadius: '55px',
    height:'34px',

    },
    statusBlock:{
        float:'left',
        margin:'0 0px 0 0',
       // width:'93px',

    },
    allStatus:{
        color: '#fff',
        float: 'left',
        border: '2px solid #464646',
        margin: '0 4px 0 0',
        padding: '8px 3px 8px 3px',
        fontSize: '12px',
        background: '#464646',
        borderRadius: '20px',
        width: '70px',
        boxShadow:'1px 1px 30px -5px rgb(0, 0, 0)',

    },
    pendingStatus:{
        color: '#000',
        padding: '10px 7px 8px 6px',
        fontSize: '12px',
        background: '#f8f2eb',
        borderRadius: '20px',
        float: 'left',
        // width: '96%',
        border:'1px solid #f98b0b',
        margin:'0 4px 0 0',
        width:'60px',

    },
    blockedStatus:{
        color: '#000',
        padding: '10px 7px 8px 6px',
        fontSize: '12px',
        background: '#fff4f4',
        borderRadius: '20px',
        float: 'left',
        // width: '96%',
        border:'1px solid #fe0000',
        margin:'0 4px 0 0',
        width:'60px',

    },
    activeStatus:{
        color: '#000',
        padding: '10px 7px 8px 6px',
        fontSize: '12px',
        background: '#e9f2e0',
        borderRadius: '20px',
        float: 'left',
        // width: '96%',
        border:'1px solid #50950b',
        margin:'0 4px 0 0',

    },

    statusLbl:{
        width: '50px',
        textAlign: 'left',
        float: 'left',
        textTransform: 'uppercase',
    fontSize: '8px',
    fontWeight:'bold',
    margin:'3px 0 0 0',

    },
    statusCount:{
        width: '20px',
    textAlign: 'right',
    float: 'right',
    fontSize: '12px',
    fontWeight:'bold',
    },

    progressWrapper:{
        background:'#e4e4e4',
        width:'100%',
        borderRadius:'30px',
        padding:'10px 10px 10px 10px',
    },
    progressBlock:{
        float:'left',
        margin:'6px 2px 0 0',
    },
    // progressheadeing:{
    //     fontSize:'10px',
    //     fontWeight:'bold',
    //     textTransform:'uppercase',
    //     float:'left',
    //     margin: '10px 0 0 0',
    // },
    progressArrowRight:{
        backgroundImage: `url("${rightArrow}")`,
        float:'left',
        width:'23px',
        height:'8px',
        margin:'8px 0 0 0px',
      },
    cercleGray:{
        float:'left',
        borderRadius:'30px',
        background:'#767676',
        width:'20px',
        height:'20px',
        margin:'0px 5px 0 0',
        border:'2px solid #767676',
        color:'#fff',
    },
    creatVendorIcon:{
        "& .MuiSvgIcon-root":{
            padding: '2px 0 0 0 !important',
            fontSize:'16px',
        },
    },
    cercleGrayTxt:{
        color:'#fff',
        fontWeight:'bold',
        padding:'4px 0 0 6px',
        float:'left',
        fontSize:'12px',

    },
    cercleGrayActive:{
        float:'left',
        borderRadius:'30px',
        background:'#fff',
        width:'20px',
        height:'20px',
        margin:'0px 5px 0 0',
        border:'2px solid #767676',
        color:'#767676',
        "& .MuiSvgIcon-root":{
            padding: '3px 0 0 0 !important',
            fontSize:'14px',
        },
    },
    progreslabel:{
        fontSize:'10px',
        textTransform:'uppercase',
        margin:'7px 2px 0 0',
        float:'left',
    },



    // Filter Section
    filterSection: {
        margin:'10px 0 10px 0',
        "& .MuiTextField-root": {

            fontSize: '2px',
            background: '#fff',
            padding: '0 0 0 0',
            borderRadius: '5px',
            border: '1px solid #333',
            margin: '2px',
            width: '222px',
        },
        "& .MuiInput-underline:before": {
            borderBottom: 'unset',
        },
        "& .MuiInput-underline:after": {
            borderBottom: '1px solid #ccc',
        },
        "& .MuiAutocomplete-inputRoot[class*='MuiOutlinedInput-root']": {

            padding: '0px 0 0 0',
        },
        "& .MuiAutocomplete-inputRoot[class*='MuiOutlinedInput-root'] .MuiAutocomplete-input": {

            padding: '6px 4px',
            fontSize: '12px',
        },
        "& .makeStyles-filterSection-149 .MuiTextField-root": {

            border: '1px solid #333',
        },
        "& .makeStyles-root-139 .MuiIconButton-root": {

            padding: '0px 0',
            margin: '0px 0',
        },
        // "& .makeStyles-root-25 .MuiIconButton-root":{

        //     padding: '4px 0',
        // },
    },
    filterheader:{
        fontSize: '14px',
        margin:'8px 0 0 0 !important',
        fontWeight:'bold',
        textTransform:'uppercase',
    },
    filterWrapper:{
        width:'100%',
    },
    dataBlock:{
        float:'left',
        width: '270px',
        height: '40px',
    },
    filterLbl: {
        float: 'left',
        margin: '10px 5px 0 0',
        fontSize: '12px',
        minWidth:'110px',
        textTransform:'uppercase',
        fontWeight:'bold',
        textAlign: 'left',

    },

    inputWrapperFilter:{

        float:"left",

        "& input":{
            borderRadius: '18px',
            border: '1px solid #ededed',
            padding: '8px 0',
            width:'126px',
            background:'#ededed',
            float:'left',
        },
        "& select":{
            borderRadius: '18px',
            border: '1px solid #ededed',
            padding: '8px 0',
            width:'126px',
            background:'#ededed',
            float:'left',
        },
        "& .MuiOutlinedInput-root":{
            position: 'relative',
            border: 'unset !important',
            float: 'left',
            width:'126px',
            padding: '0px 0',
            background: '#ededed',
            borderRadius: '18px',
        },
        "& .MuiOutlinedInput-input":{
            padding: '8px 15px 8px 5px',
        fontSize: '12px',
        textAlign: 'left',
        },        
    },
    inputWrapperFilterFull:{

        float:"left",

        "& input":{
            borderRadius: '18px',
            border: '1px solid #ededed',
            padding: '8px 0',
            width:'100%',
            background:'#ededed',
            float:'left',
            minWidth: '70px',
        },
        "& select":{
            borderRadius: '18px',
            border: '1px solid #ededed',
            padding: '8px 0',
            width:'100%',
            background:'#ededed',
            float:'left',
        },
        "& .MuiOutlinedInput-root":{
            position: 'relative',
            border: 'unset !important',
            float: 'left',
            width:'100%',
            padding: '0px 0',
            background: '#ededed',
            borderRadius: '18px',
        },
        "& .MuiOutlinedInput-input":{
            padding: '8px 15px 8px 5px',
            fontSize: '12px',
            textAlign: 'left',
        },
        "& .MuiFormControl-marginNormal":{
            marginTop: 0,
        },
        "& .MuiAutocomplete-input":{
            minWidth: '150px',
        },
        
    },
    inputWrapper:{

        "& input":{
            borderRadius: '18px',
            border: '1px solid #ededed',
            padding: '8px 0',
            width:'126px',
            background:'#ededed',
            float:'left',
        },
        "& select":{
            borderRadius: '18px',
            border: '1px solid #ededed',
            padding: '8px 0',
            width:'126px',
            background:'#ededed',
            float:'left',
        },
        "& .MuiOutlinedInput-root":{
            border: 'unset !important',
    padding: '0px 0',
    position: 'relative',
    background: '#ededed',
    float: 'left',
    borderRadius: '4px',
    width: '100%',
        },
        "& .MuiOutlinedInput-input":{
            padding:'10px 5px',
            borderRadius:'0 4px 4px 0',
            textAlign:'left',
            maxHeight: '20px',
        },
    },

    inputWrapperAccSub:{

        "& input":{
            borderRadius: '18px',
            border: '1px solid #ededed',
            padding: '8px 0',
            width:'126px',
            background:'#ededed',
            float:'left',
        },
        "& select":{
            borderRadius: '18px',
            border: '1px solid #ededed',
            padding: '8px 0',
            width:'126px',
            background:'#ededed',
            float:'left',
        },
        "& .MuiOutlinedInput-root":{
            border: 'unset !important',
    padding: '0px 0',
    position: 'relative',
    background: '#ededed',
    float: 'left',
    borderRadius: '4px',
    width: '126px',
        },
        "& .MuiOutlinedInput-input":{
            padding:'10px 5px',
            borderRadius:'0 4px 4px 0',
            textAlign:'left',
            maxHeight: '20px',
        },
    },

    tblStatusPending:{
        border:'2px solid #f98b0b',
        color:'#f98b0b',
        borderRadius: '20px',
        textAlign: 'center',
        padding: '5px 0 5px 0',
        fontWeight: 'bold',
        width: '135px',
        margin: '0 auto',
    },
    tblStatusActive:{
        border:'2px solid #81bf49',
        color:'#81bf49',
        borderRadius: '20px',
        textAlign: 'center',
        padding: '5px 0 5px 0',
        fontWeight: 'bold',
        width: '135px',
        margin: '0 auto',
    },
    tblStatusBlocked:{
        border:'2px solid #e03030',
        color:'#e03030',
        borderRadius: '20px',
        textAlign: 'center',
        padding: '5px 0 5px 0',
        fontWeight: 'bold',
        width: '135px',
        margin: '0 auto',
    },
    tblRowRemoveStatus:{
        border:'2px solid #e03030',
        // color:'#e03030',
        borderRadius: '20px',
        //textAlign: 'center',
        padding: '2px 0 2px 5px',
        //fontWeight: 'bold',
        //width: '135px',
        margin: '0 auto',
        display: 'block'
    },
    tblRowAddedStatus:{
        border:'2px solid #81bf49',
        // color:'#e03030',
        borderRadius: '20px',
        //textAlign: 'center',
        padding: '2px 0 2px 5px',
        //fontWeight: 'bold',
        //width: '135px',
        margin: '0 auto',
        display: 'block'
    },
    tblRowChangedStatus:{
        border:'2px solid #f98b0b',
        // color:'#e03030',
        borderRadius: '20px',
        //textAlign: 'center',
        padding: '2px 0 2px 5px',
        //fontWeight: 'bold',
        //width: '135px',
        margin: '0 auto',
        display: 'block'
    },
    pendingCountTbl:{
        background:'#f98b0b',
        borderRadius:'20px',
        padding:'5px 10px',
        float:'right',
        color:'#fff',
        margin:'-5px 0 0 0',
    },

    approveBtn:{
        fontSize:'12px',
        color:'#50950B',
        float:'left',
     
        "& .MuiSvgIcon-root":{
          fontSize:'32px !important',
          color:'#50950B',
          float:'left',
        },
        "& button":{
         background: 'unset !important',
         border: 'unset !important',
         color: '#50950B !important',
         padding:'0',
        },
        "& button:hover":{
         textDecoration:'none',
         cursor:'pointer !important',
     
        },
     
      },
      approveBtnTxt:{
        color:'#50950B',
       float: 'left',
       margin: '10px 0 0 0',
       textTransform:'uppercase',
       fontSize:'11px',
       fontWeight:'bold',
      },
      /////////
      editBtn:{
        fontSize:'12px',
        color:'#0084ff',
        float:'left',
     
        "& .MuiSvgIcon-root":{
          fontSize:'28px !important',
          color:'#0084ff',
          float:'left',
        },
        "& button":{
         background: 'unset !important',
         border: 'unset !important',
         color: '#0084ff !important',
         padding:'0',
        },
        "& button:hover":{
         textDecoration:'none',
         cursor:'pointer !important',
     
        },
     
      },
      editBtnTxt:{
        color:'#0084ff',
       float: 'left',
       margin: '10px 0 0 0',
       textTransform:'uppercase',
       fontSize:'11px',
       fontWeight:'bold',
      },
////////////
      rejectBtn:{
        fontSize:'12px',
        color:'#EA1B1B',
        float:'right',
     
        "& .MuiSvgIcon-root":{
          fontSize:'32px !important',
          color:'#EA1B1B',
          float:'left',
        },
        "& button":{
         background: 'unset !important',
         border: 'unset !important',
         color: '#EA1B1B !important',
         padding:'0',
        },
        "& button:hover":{
         textDecoration:'none',
         cursor:'pointer !important',
     
        },
     
      },
      rejectBtnTxt:{
        color:'#EA1B1B',
       float: 'left',
       margin: '10px 0 0 0',
       textTransform:'uppercase',
       fontSize:'11px',
       fontWeight:'bold',
       
      },
      extend:{
        borderRadius:'30px',
        background:'#0a8439',
        color:'#fff',
        fontSize:'14px',
        textTransform:'uppercase',
        float: 'left',
        padding: '4px 15px',
        fontWeight:'bold',
      },
      block:{
        borderRadius:'30px',
        background:'#b41212',
        color:'#fff',
        fontSize:'14px',
        textTransform:'uppercase',
        float: 'right',
        padding: '4px 15px',
        fontWeight:'bold',
      },
      unblock:{
        borderRadius:'30px',
        background:'#363636',
        color:'#fff',
        fontSize:'14px',
        textTransform:'uppercase',
        float: 'left',
        padding: '4px 10px',
        fontWeight:'bold',
      },
      clltoMobile:{
        borderRadius:'30px',
        background:'#fff',
        color:'#2176FF',
        fontSize:'14px',
        textTransform:'uppercase',
        float: 'left',
        padding: '4px 16px',
        border:'1px solid #fff',
        boxShadow: '1px 1px 23px -5px rgba(49,182,207,0.73)',
        fontWeight:'bold',
        "& .MuiSvgIcon-root":{
            fontSize:'22px !important',
            color:'#2176FF',
            float:'left',
          },
          "& span":{
            float: 'left',
            margin: '2px 0 0 0',
          },
      },
      toolTipLbl:{
        background:'#000',
        color:'#fff',
        padding: '2px 6px',
        margin: '0 0 0 4px',
        borderRadius: '3px',
        cursor: 'pointer',
      },
      ArrowGo:{
          "& .MuiSvgIcon-root":{
              fontSize:'18px  !important',
              color:'#c3c3c3 !important',
          },
          "& button":{
            background: '#fff',
            border: 'none',
            cursor:'pointer',
          },
      },
      greenBtnWrapper:{
        float: 'right',
        //margin: '-18px 0px 0 10px',
        "& button":{
            background: '#19C626 !important',
        fontSize: '12px',
        color: '#fff',
        borderRadius: '20px',
        padding: '5px 12px',
        fontWeight:'bold',
    },
    "& .MuiButton-root:hover":{
        color: '#fff',
        fontSize: '12px',
        background: '#00b50a !important',
        borderRadius: '20px',
        padding: '5px 12px',
    },

    
    },

    grayBtnWrapper:{
        float: 'right',
        margin: '-18px 0px 0 10px',
        [theme.breakpoints.down("xs")]: {
            margin: '5px 0px 0 10px',
        },
            "& button":{
                background: '#333 !important',
        fontSize: '12px',
        color: '#fff',
        borderRadius: '20px',
            padding: '5px 25px',
            fontWeight:'bold',
        },
        "& .MuiButton-root:hover":{
            background: '#333 !important',
            fontSize: '12px',
            color: '#fff',
            borderRadius: '20px',
            padding: '5px 25px',
        },
    },
    searchBtnWrapper:{
        float: 'left',
        "& button":{
         //background: '#19C626 !important',
         background: '#1976d2 !important',
        fontSize: '12px',
        color: '#fff',
        borderRadius: '20px',
        padding: '5px 25px',
        fontWeight:'bold',
    },
    "& .MuiButton-root:hover":{
        color: '#fff',
        fontSize: '12px',
        background: 'rgb(17, 82, 147) !important',
        borderRadius: '20px',
        padding: '5px 25px',
    },

    
    },
    addNewBtnWrapper:{
        float: 'right',
        "& button":{
            background: '#19C626 !important',
    fontSize: '12px',
    color: '#fff',
    borderRadius: '20px',
        padding: '5px 8px',
        fontWeight:'bold',
    },
    "& .MuiButton-root:hover":{
        color: '#fff',
        fontSize: '12px',
        background: '#00b50a !important',
        borderRadius: '20px',
        padding: '5px 8px',
    },

    
    },

    popUpOuter:{
        "& .Mui-disabled":{
         opacity: '0.6 !important',
         color: '#fff  !important',
        }, 
        "& .MuiDialog-paperWidthSm":{
         maxWidth: '600px',
         overflow: 'initial',
        },
        "& .MuiDialogTitle-root ":{
         flex: '0 0 auto',
         margin: '0',
         position: 'relative',
         padding: '16px 24px',
         //z-index: '1',
        },
        "& .MuiOutlinedInput-input":{
            float: 'left !important',
            width: '100% !important',
            padding: '10px 2px !important',
            background: '#f7fcff',
            borderRadius: '4px',
        },
 
     },
     popUpHeader:{
        backgroundImage: 'linear-gradient(to right, #890e34, #ce0623)',
        padding:'14px 12px 10px 24px !important',
        borderRadius:'0px 0px 0 0',
       "& h2":{
        color: '#fff',
        fontWeight: 'normal',
        textTransform: 'uppercase',
        position: 'relative',
       },
    },
    NoPopWrapper:{
        "& .MuiOutlinedInput-input":{
           float: 'left',
           width: '100%',
           padding: '10px 0 10px 2px',
           background: '#f7fcff',
           borderRadius: '4px',
        },
        "& .MuiFormControl-root":{
           margin: '0 10px 0 0',
        },
    },

    popUpLBL:{
        textTransform:'uppercase',
        fontSize:'12px',
        margin:'0 2px 0 0',
    },
    popUpAddBtn:{
        "& .MuiSvgIcon-root":{
         color: '#28b600',
         float: 'left',
        },
 
     },
     popdataRow:{},
     createLbl: {
        textAlign: 'left',
        float: 'left',
        fontSize: '12px',
        fontWeight: 'bold',
        textTransform: 'uppercase',
        margin: '12px 0 2px 0',
        width:'100%',

    },

    inputWrapper_Req: {
        margin:'10px 0 10px 0',
        float:'left',
        width:'100%',
"& .MuiChip-root":{
    height: '23px',
},
        "& .MuiInputBase-root":{
            borderRadius: '4px',
                    //border: '1px solid #c0c1c1',
                     padding: '0px 0',
                     width:'100%',
                     background:'#f7fcff',
                     float: 'left',

        },
        "& .MuiOutlinedInput-input":{
            padding:'10px 5px',
            borderRight:'5px solid #ed1c24',
            borderRadius:'0 4px 4px 0',
            textAlign:'left',
            maxHeight: '20px',
        },
        "& .MuiInput-root": {
            position: 'relative',
            width: '100%',
            border: '1px solid #ed1c24 !important',
            borderRadius: '4px',
            padding: '4px 0',
            background:'#f7fcff',
            float: 'left',
            borderRight: '5px solid #ed1c24 !important',
        },
        "& .MuiTextField-root": {

            fontSize: '2px',
            background: '#fff',
            padding: '0 0 0 0',
            borderRadius: '5px',
            border: 'unset',
            margin: '2px',
            width: '100%',
        },
        "& .MuiInput-underline:before": {
            borderBottom: 'unset',
        },
        "& .MuiInput-underline:after": {
            borderBottom: '1px solid #ccc',
        },
        "& .MuiAutocomplete-inputRoot[class*='MuiOutlinedInput-root']": {

            padding: '0px 0 0 0',
        },
        "& .MuiAutocomplete-inputRoot[class*='MuiOutlinedInput-root'] .MuiAutocomplete-input": {

            padding: '6px 4px',
            fontSize: '12px',
        },
        "& .makeStyles-filterSection-149 .MuiTextField-root": {

            border: '1px solid #333',
        },
        "& .makeStyles-root-139 .MuiIconButton-root": {

            padding: '0px 0',
            margin: '0px 0',
        },
        "& select":{
            borderRadius: '4px',
           border: '1px solid #c0c1c1',
            padding: '12px 0',
            width:'100%',
            background:'#f7fcff',
            float: 'left',
            borderRight: '5px solid #ed1c24 !important',
      },
        "& .makeStyles-root-25 .MuiIconButton-root":{

        padding: '4px 0',
        },
        "& .MuiList-padding":{
            paddingTop:'10px !important',
        },
    },

    createHeader:{
        padding:'10px 0px 10px 0',
    },
    createHeaderLine:{
        height: '2px',
        margin: '8px 0 0 5px',
        display: 'flex',
        padding: '0 !important',
        minWidth: '81%',
        background: '#e2e2e2',
    
    },
    createHeaderTxt:{
        fontWeight: 'bold',
        textTransform: 'uppercase',
        fontSize: '16px',
        textAlign:'left',
        marginLeft: '10px',
    },
}));

export default  useStyles;
